import { HostnameService } from 'src/app/shared/services/basic/hostname.service';
import { BasicModel } from './../models/basic/basic.model';
import { APICONSTANTS } from './../constants/api-constants';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, of, BehaviorSubject, throwError, ReplaySubject } from 'rxjs';
import { HttpRequest, HttpEvent, HttpResponse, HttpHandler, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filter, tap } from 'rxjs/operators';


class DateAndBehaviorResponse {
  dateMaxValid: number;
  response: ReplaySubject<HttpEvent<BasicModel>>;
}

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  public cache: Map<string, DateAndBehaviorResponse> = new Map<string, DateAndBehaviorResponse>();
  private urlsToCatched: string[] = [];
  private urlsToCatchedDashboard: string[] = [];
  helper: JwtHelperService;
  dureRetention = 100; // 0.1 s
  dureRetentionRef = 3600000; // 60 minutes
  dureRetentionDashboard = 180000; // 3 minutes
  constructor(
    private hostnameService: HostnameService) {
                //dashboards
                this.urlsToCatchedDashboard.push((this.hostnameService.getUrl() + 'api/bc/GetDashboardAllBcs'));
                this.urlsToCatchedDashboard.push((this.hostnameService.getUrl() + 'api/bc/GetDashboardMyBcs'));
                this.urlsToCatchedDashboard.push((this.hostnameService.getUrl() + 'api/bc/GetDashboardValidationBcs'));
                this.urlsToCatchedDashboard.push((this.hostnameService.getUrl() + 'api/Bp/GetDashboard'));

                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/fournisseur/GetAll/'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/ca1/GetAll/'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/site/GetAll/'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/modeRegl/GetAll/'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/condRegl/GetAll/'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/tva/GetAll/'));

                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/societe/Get'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/Na/GetFromCa1'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/ca1/GetFromSite'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/site/getFromCodeAndSociete'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/fournisseur/getFromCodeAndSociete'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/Comp/GetFromNa'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/ca2/getFromNaCa1'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/fournisseur/GetFromSociete'));

                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/CgCharge/GetFromSociete/'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/site/GetFromSociete'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/jProvis/GetFromSociete'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/cgProvis/GetFromSociete'));
                this.urlsToCatched.push((this.hostnameService.getUrl() + 'api/article/GetFromSocieteSite'));
              }

  public newRequest(request: HttpRequest<any>, httpResponse: Observable<HttpEvent<any>>): Observable<HttpEvent<any>> {
    if (this.containsOrStartWithRef((request.url))) {
      httpResponse = this.saveInCache(request, httpResponse, this.dureRetentionRef);
      return httpResponse;
    } else if(this.containsOrStartWithDashboard((request.url))) {
      httpResponse = this.saveInCache(request, httpResponse, this.dureRetentionDashboard);
      return httpResponse;
    } else if(request.method.localeCompare("GET") === 0) {
      httpResponse = this.saveInCache(request, httpResponse, this.dureRetention);
      return httpResponse;
    } else {
      return httpResponse;
    }
  }

  public getFromCache(request: HttpRequest<any>): Observable<HttpEvent<any>>{
    const url = (request.url);
    const cachedResponse: DateAndBehaviorResponse = this.cache.get(url);
    if (cachedResponse) {
      // si dateMaxValid < date du jour => suppression de l'enregistrement cache + return null;
      if (cachedResponse.dateMaxValid < Date.now()) {
        this.removeFromCache(request);
        return null;
      }
      return cachedResponse.response;
    } else {
      return null;
    }
  }

  public saveInCache(request: HttpRequest<any>,
                     httpResponse: Observable<HttpEvent<any>>,
                     dureRetention: number): Observable<HttpEvent<any>>{
    // enregistrement Date + durée vie requette;
    const sub: DateAndBehaviorResponse = {
      dateMaxValid: (Date.now() + dureRetention),
      response: new ReplaySubject<HttpEvent<any>>(1)
    };
    httpResponse.subscribe(sub.response);
    this.cache.set(request.url, sub);
    return sub.response;
  }

  public removeFromCache(request: HttpRequest<any>): void {
    this.cache.delete(request.url);
  }

  containsOrStartWithRef( url: string): boolean{
    if (this.urlsToCatched.includes(url)) {
      return true;
    }
    for (const element of this.urlsToCatched){
      if (url.startsWith(element)) {
        return true;
      }
    }
    return false;
  }
  containsOrStartWithDashboard( url: string): boolean{
    if (this.urlsToCatchedDashboard.includes(url)) {
      return true;
    }
    for (const element of this.urlsToCatchedDashboard){
      if (url.startsWith(element)) {
        return true;
      }
    }
    return false;
  }
}
